import Vue from 'vue'
import VueGeolocation from 'vue-browser-geolocation';
Vue.use(VueGeolocation);
